import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ApiResponse } from '../shared/types';

export interface RewashSettingsRow {
  id: string;
  admin_id: string;
  window_minutes: number;
  updated_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface RewashSettingsMetadata {
  window_minutes_min: number;
  window_minutes_max: number;
}

export type RewashSettingsResponse = ApiResponse<RewashSettingsRow | null> & RewashSettingsMetadata;

export interface RewashSettingsUpdatePayload {
  window_minutes: number;
}

@Injectable({ providedIn: 'root' })
export class RewashSettingsService {
  constructor(private api: ApiService) {}

  getRewashSettings(): Observable<RewashSettingsResponse> {
    return this.api.get<RewashSettingsRow | null>(
      'order/rewash-settings'
    ) as Observable<RewashSettingsResponse>;
  }

  updateRewashSettings(payload: RewashSettingsUpdatePayload): Observable<RewashSettingsResponse> {
    return this.api.put<RewashSettingsRow | null>(
      'order/rewash-settings',
      payload
    ) as Observable<RewashSettingsResponse>;
  }

  deleteRewashSettings(): Observable<RewashSettingsResponse> {
    return this.api.delete<RewashSettingsRow | null>(
      'order/rewash-settings'
    ) as Observable<RewashSettingsResponse>;
  }
}
